/// <reference path="../../../../components/models/meevo.model.custom.ts" />
///<reference path="../report-controls-list/report-controls-list.component.ts"/>

module Meevo.Plugins.Reports {

    import ISelectItem = Meevo.Model.ISelectItem;

    interface IParameter {
        clrType: string;
        controlId: number;
        dbType: string;
        name: string;
        sequence: number;
    }

    interface ICO001Model {
        ViewReportByCO001: TRunReportIn;
        MembershipBenefitDiscountsStartDate: Date;
        MembershipBenefitDiscountsEndDate: Date;
        GroupByLocation: boolean;
        SortReportByCO001: TSortReportBy;
        OrderLocationsBy: TOrderLocationBy;
        selectedPreset: {
            name: string;
            status: number;
        };
    }

    interface IValue {
        displayName: string;
        id: number;
        locationId: number;
        languageId: number;
        sortOrder: number;
        value: string;
    }

    interface IOptions {
        displayName: string;
        id: number;
        parameters: IParameter[];
        reportControlEnumType: number;
        securityAttribId: number;
        sequence: number;
        values: IValue[];
    }

    type TRunReportIn = 'Summary Mode' | 'Detail Mode';
    type TSortReportBy = 'Location' | 'Date' | 'Item Type';
    type TOrderLocationBy = 'Alphabetical' | 'Qty Discounted' | 'Total Amount Off';

    const summarySortReportBy: ISelectItem<TSortReportBy>[] = [
        { label: 'LABEL_LOCATION', value: 'Location' },
        { label: 'LABEL_ITEM_TYPE', value: 'Item Type' }
    ]

    const detailSortReportBy: ISelectItem<TSortReportBy>[] = [
        { label: 'LABEL_DATE', value: 'Date' },
        { label: 'LABEL_ITEM_TYPE', value: 'Item Type' }
    ]

    const defaultOrderLocationBy: ISelectItem<TOrderLocationBy>[] = [
        { label: 'LABEL_ALPHABETICAL', value: 'Alphabetical' },
        { label: 'LABEL_QTY_DISCOUNTED', value: 'Qty Discounted' },
        { label: 'LABEL_TOTAL_AMOUNT_OFF', value: 'Total Amount Off' },
    ]

    class MeevoReportCo001Component implements angular.IComponentController {
        public mainModel: ICO001Model;
        public reportForData: IValue[];
        public sortReportByData: ISelectItem<TSortReportBy>[] = this.checkRunReportIn();
        public sortOrderByData: ISelectItem<TOrderLocationBy>[] = defaultOrderLocationBy;
        public options: IOptions;
        public isGroupByLocation: boolean = false;

        $onInit(): void {
            this.reportForData = this.options.values;
        }

        set runReportForValue(value: TRunReportIn | null) {
            if (this.mainModel != null) {
                this.mainModel.ViewReportByCO001 = value;
                if (value === 'Detail Mode') {
                    this.sortReportByData = detailSortReportBy;
                    this.mainModel.GroupByLocation = false;
                    this.mainModel.SortReportByCO001 = detailSortReportBy[0].value;
                } else {
                    this.sortReportByData = summarySortReportBy;
                    this.isGroupByLocation = false;
                    this.mainModel.GroupByLocation = false;
                    this.mainModel.SortReportByCO001 = summarySortReportBy[0].value;
                }
            }
        }

        get runReportForValue(): TRunReportIn | null {
            if (this.mainModel) {
                return this.mainModel.ViewReportByCO001;
            } else {
                return null;
            }
        }

        public groupByChanged(value: boolean) {
            if (value) {
                this.isGroupByLocation = true;
                this.mainModel.OrderLocationsBy = defaultOrderLocationBy[0].value;
            } else {
                this.isGroupByLocation = false;
            }
        }

        checkRunReportIn(): ISelectItem<TSortReportBy>[] {
            if (this.mainModel.ViewReportByCO001 === 'Detail Mode') {
                return detailSortReportBy;
            } else {
                return summarySortReportBy;
            }
        }
    }

    angular.module('meevo.plugins.reports')
        .component('meevoReportCo001Component', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/reports/components/report-control-co001/report-control-co001.component.html',
            controller: MeevoReportCo001Component,
            controllerAs: '$ctrl',
            bindings: {
                parameterNames: '<',
                hierarchyForm: '<',
                validationJson: '<',
                mainModel: '<',
                disabled: '=?ngDisabled',
                options: '<',
            }
        });
}